import React from "react";
import { Calendar, momentLocalizer } from "react-big-calendar";
import "react-big-calendar/lib/css/react-big-calendar.css";
import moment from "moment-timezone";
import "./index.css";
import {
  formatTimeRange,
  getModeIcon,
  getStatusColor,
  getStatusText,
} from "../../utils";
import { getHref } from "../../utils/navigation";
const localizer = momentLocalizer(moment);

// Custom header to show date and day
function CustomDateHeader({ date }) {
  const now = new Date();
  const isToday = moment(date).isSame(now, "day");

  return (
    <div className={`custom-header ${isToday ? "today" : ""}`}>
      <div>{moment(date).format("ddd")}</div>
      <div>{moment(date).format("D")}</div>
    </div>
  );
}

// Function to convert the given data into events for the calendar
const convertDataToEvents = (data) => {
  console.log("data====>", data);
  const events = [];

  // Loop through each appointment in data
  data.forEach((appointment) => {
    const startDateTime = moment
      .tz(
        `${appointment.date} ${appointment.startTime}`,
        "YYYY-MM-DD HH:mm:ss",
        "Asia/Kolkata"
      )
      .toDate();

    const endDateTime = moment
      .tz(
        `${appointment.date} ${appointment.endTime}`,
        "YYYY-MM-DD HH:mm:ss",
        "Asia/Kolkata"
      )
      .toDate();

    console.log("Start DateTime (IST):", startDateTime);
    console.log("End DateTime (IST):", endDateTime);

    events.push({
      title: `${appointment.firstName || "Anonymous"} ${
        appointment.lastName || ""
      }`,
      start: startDateTime,
      end: endDateTime,
      appointmentData: appointment,
      appointmentId: appointment.appointmentId,
      uid: appointment.uid,
    });
  });

  return events;
};

function Index({ loading, error, data }) {
  const events = convertDataToEvents(data || []);

  // Event renderer for custom event rendering
  function CustomEvent({ event }) {
    const appointment = event.appointmentData;

    return (
      <a
        href={getHref("/appointment-detail/" + event.appointmentId + "/" + event.uid)}
        style={{ textDecoration: "none" }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            padding: "4px",
            borderRadius: "8px",
          }}
        >
          <img
            src={appointment.imageURL}
            alt="avatar"
            style={{ width: "24px", height: "24px", borderRadius: "50%" }}
          />
          <div style={{ display: "flex", flexDirection: "column" }}>
            <span className="text-sm text-[#171717] font-poppins font-normal">
              {event.title}
            </span>
            <span className="text-sm text-[#334155] font-poppins font-normal">
              {formatTimeRange(appointment.startTime, appointment.endTime)}
            </span>
          </div>
          <div className="w-[24px] h-[24px] rounded-full flex justify-center items-center bg-[#ffffff]">
            <img
              src={getModeIcon(appointment.mode)}
              alt="mode"
              className="w-3 h-3" // Adjust the width and height of the icon if needed
            />
          </div>
        </div>
      </a>
    );
  }

  return (
    <div className="p-2">
      <Calendar
        localizer={localizer}
        defaultDate={new Date()}
        events={events}
        defaultView="week"
        views={["week"]}
        step={60}
        timeslots={1}
        min={new Date(2025, 4, 15, 0, 0)}
        max={new Date(2025, 4, 15, 23, 59)}
        components={{
          event: CustomEvent,

          header: CustomDateHeader,
          timeGutterHeader: () => (
            <div
              style={{
                textAlign: "center",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
                width: "100px",
                fontSize: "16px",
                fontWeight: 500,
                fontFamily: "Poppins",
                color: "#171717",
                marginLeft: "80px !important",
              }}
            >
              Time
            </div>
          ),
          timeGutterWrapper: ({ children }) => <div>{children}</div>,
          timeSlotWrapper: ({ children }) => (
            <div
              style={{
                textAlign: "center",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100px",
                width: "100px",
                fontSize: "14px",
                fontWeight: 500,
                fontFamily: "Poppins",
                color: "#171717",
                marginLeft: "-20px",
              }}
            >
              {children}
            </div>
          ),
        }}
        style={{ height: "90vh" }}
      />
    </div>
  );
}

export default Index;
